// extracted by mini-css-extract-plugin
export default {"companyContainer":"RF-z","companyImage":"SF-z","container":"TF-z","heading":"UF-z","darkText":"VF-z","smallHeading":"WF-z","darkBackground":"XF-z","whiteBackground":"YF-z"};